import { FormGroup } from '@angular/forms';

export default class FormHelper {
  static markAsDirtyAll(form: FormGroup) {
    Object.values(form.controls).forEach((control) => {
      if (control.invalid) {
        control.markAsDirty();
        control.updateValueAndValidity({ onlySelf: true });
      }
    });
  }
}
